import React from 'react';
import PropTypes from 'prop-types';
import css from './FormGrid.module.scss';

const FormGrid = ({
  label,
  children,
  columns = 1,
  className = '',
  style,
  required = false,
}) => {
  return (
    <div 
      className={`${css.formGrid} ${className}`}
      style={{'--grid-columns': columns, ...style}}
    >
      {label && (
        <label className={css.formLabel}>
          {label}
          {required && <span className={css.required}>*</span>}
        </label>
      )}
      {React.Children.map(children, (child) => (
        child &&
          <div
            className={css.formGridItem}
            style={{ gridColumn: `span ${child.props.columnSpan || 1}` }}
          >
            {child}
          </div>
      ))}
    </div>
  );
};

FormGrid.propTypes = {
  children: PropTypes.node.isRequired,
  columns: PropTypes.number,
  className: PropTypes.string
};

export default FormGrid;
